<template>
  <main>
    <HomeTab @shop="scrollTo('collection')" />
    <AllProducts :items="products" @add-to-cart="$emit('add-to-cart', $event)" />
    <CarAromas :items="carAromas" @add-to-cart="$emit('add-to-cart', $event)" />

    <footer class="site-footer">
      <div>
        <span class="site-footer__brand">CHER</span>
        <p>Fine fragrances, blended in Goa.</p>
      </div>
      <div class="site-footer__links">
        <a href="#collection">Collection</a>
        <a href="#car-aromas">Car aromas</a>
        <a href="https://www.instagram.com/cher_goa" target="_blank" rel="noopener">Instagram</a>
      </div>
      <p>© {{ year }} CHER</p>
    </footer>
  </main>
</template>

<script>
import HomeTab from './HomeTab.vue'
import AllProducts from './AllProducts.vue'
import CarAromas from './CarAromas.vue'
import { products, carAromaProducts } from '../data/products'

export default {
  name: 'HomePage',
  components: { HomeTab, AllProducts, CarAromas },
  data: () => ({
    products,
    carAromas: carAromaProducts,
    year: new Date().getFullYear()
  }),
  methods: {
    scrollTo(id) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.site-footer { display: grid; grid-template-columns: 1fr auto 1fr; align-items: end; gap: 40px; padding: 65px 6vw 35px; color: #afa69d; background: #1e1b18; font-size: 11px; }
.site-footer__brand { color: #fff; font-family: Georgia, serif; font-size: 28px; letter-spacing: 8px; }
.site-footer p { margin: 12px 0 0; }
.site-footer > p { text-align: right; }
.site-footer__links { display: flex; gap: 25px; }
.site-footer a { color: #d3ccc5; text-decoration: none; }
@media (max-width: 650px) {
  .site-footer { grid-template-columns: 1fr; align-items: start; }
  .site-footer > p { text-align: left; }
  .site-footer__links { flex-wrap: wrap; }
}
</style>
